export const PUNCHOUT_TYPES = {
  OCI: 'OCI',
  CXML: 'CXML',
}
